<template>
    <div>
        <div class="m-portlet m-b-10">
            <div class="m-portlet__head" style="width: 100%">
                <div class="m-portlet__head-caption" style="width: 100%">
                    <div class="m-portlet__head-title" style="width: 100%">
                        <el-row :gutter="20" style="width: 100%">
                            <el-col :span="2">
                                <el-button @click="handleAddTemplate()">添加模板</el-button>
                            </el-col>
                            <el-col :span="2">
                                <el-button v-if="activeList===true" @click="handleChangeList()">切换个人模式</el-button>
                                <el-button v-if="activeList===false" @click="handleChangeList()">切换模板模式</el-button>
                            </el-col>
                        </el-row>
                    </div>
                </div>

            </div>
        </div>
        <div>
            <div >
                <AuthorityList v-if="activeList===true"></AuthorityList>
                <AnotherAuthorityList v-if="activeList===false"></AnotherAuthorityList>
            </div>
        </div>
    </div>

</template>

<script>
    import AnotherAuthorityList from './AnotherAuthorityList'
    import AuthorityList from './AuthorityList'

    export default {
        name: "List",
        data() {
            return {
                path: '/authority',
                activeList: true,
                loading: true,
                sections: [],
                checkedStudentPowers: [],
                checkedClassroomPowers: [],
                checkedCoursePowers: [],
                checkedClassPowers: [],
                checkedHeadTeacherPowers: [],
                checkedDayTimeTablePowers: [],
                checkedTimeTablePowers: [],
                checkedMonthlyTimeTablePowers: [],
                checkedExamPowers: [],
                checkedSemesterPowers: [],
                checkedSenatePowers: [],
                checkedSignLogPowers: [],
                checkedSittingPowers: [],
                checkedFinancialPowers: [],
                checkedInvoicePowers: [],
                checkedReturnVisitPowers: [],
                checkedEmployeePowers: [],
                checkedAuthorityPowers: [],
                checkedMenuPowers: [],
                checkedReferrerPowers: [],
                checkedHomePowers: [],
                checkedCartPowers: [],
                allCheckedPowers: [],
                button_loading: false,
                allPowers: {},
                search_loading: false,
                anotherAuthorityList: {
                    checkedEmployee: '',
                    employees: [],
                    total: 0,
                    leftLoading: true,
                    rightLoading: true,
                    powerTemplates: [],
                    index: '',
                    searchIndexTemplates: [],
                    searchTemplates: [],
                    checkKey: false,
                },
                authorityList: {
                    total: 0,
                    employees: [],
                    powerTemplates: [],
                    searchIndexTemplates: [],
                    searchTemplates: [],
                    button_loading: false,
                    leftLoading: true,
                    rightLoading: true,
                },
                dialog_AddPowerTemplate: {
                    button_loading: false,
                },
                dialog_TemplateUpdateEmployeePower: {
                    checkedSection: [],
                    employee: [],
                    loading: true,
                    button_loading: false,
                },
                dialog_UpdatePowerTemplate: {
                    loading: true,
                    button_loading: false,
                    name: '',
                },
                dialog_UpdateEmployee:{
                    employee:{
                        id:'',
                        name:'',
                        phone:'',
                        new_role:[],
                        status:''
                    },
                    button_loading:false,
                    status_type:[
                        {
                            id:'active',
                            name:'在职'
                        },{
                            id:'cancel',
                            name:'离职'
                        }
                    ],
                    roles:[
                        {
                            id:'teacher',
                            name:'老师'
                        },{
                            id:'headTeacher',
                            name:'班主任'
                        }
                    ]
                },
                dialog_UpdateAccount:{
                    phone:'',
                    new_phone:'',
                    button_loading:false,
                }
            }
        },
        components: {
            AnotherAuthorityList,
            AuthorityList
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        created() {
            this.handleCreate();
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData);
                this.$wApi.send(this.path, 'get_sections');
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'search_employeeAndTemplate':
                        if (data.type == 'searchEmployee') {
                            this.anotherAuthorityList.searchEmployees = JSON.parse(JSON.stringify(data.employees));
                            this.authorityList.searchEmployees = JSON.parse(JSON.stringify(data.employees));
                        }
                        else if (data.type == 'searchTemplate') {
                            this.anotherAuthorityList.searchTemplates = JSON.parse(JSON.stringify(data.powerTemplates));
                            this.authorityList.searchTemplates = JSON.parse(JSON.stringify(data.powerTemplates));
                        }
                        this.search_loading = false;
                        break;
                    case 'get_sections':
                        this.sections = data.get_sections;
                        break;
                    case 'get_employeeIndex':
                        if (Object.keys(data.employees).length > 0) {
                            this.anotherAuthorityList.employees = JSON.parse(JSON.stringify(data.employees));
                            this.authorityList.employees = JSON.parse(JSON.stringify(data.employees));
                        } else {
                            this.anotherAuthorityList.employees = new Object();
                            this.authorityList.employees = new Object();
                        }
                        this.anotherAuthorityList.powerTemplate = JSON.parse(JSON.stringify(data.powerTemplate));
                        this.authorityList.powerTemplate = JSON.parse(JSON.stringify(data.powerTemplate));

                        this.anotherAuthorityList.total = JSON.parse(JSON.stringify(data.total));
                        this.authorityList.total = JSON.parse(JSON.stringify(data.total));
                        this.anotherAuthorityList.rightLoading = false;
                        this.authorityList.rightLoading = false;
                        break;
                    case 'give_employee_to_template':
                        this.$message({
                            message: '员工添加成功',
                            type: 'success'
                        });
                        for (let key in data.give_employee_to_template) {
                            this.$set(this.authorityList.employees, key, data.give_employee_to_template[key]);
                            this.authorityList.total += 1;
                        }
                        this.authorityList.button_loading = false;
                        break;
                    case 'delete_powerTemplate':
                        this.$delete(this.anotherAuthorityList.powerTemplates, data.id);
                        this.$delete(this.authorityList.powerTemplates, data.id);
                        this.authorityList.employees = data.employees;
                        this.authorityList.total = data.total;
                        this.authorityList.rightLoading = false;
                        this.$message({
                            message: '权限模板删除成功',
                            type: 'success'
                        });
                        this.authorityList.button_loading = false;
                        break;
                    case 'get_templateIndex':
                        if (Object.keys(data.powerTemplates).length > 0) {
                            this.anotherAuthorityList.powerTemplates = JSON.parse(JSON.stringify(data.powerTemplates));
                            this.authorityList.powerTemplates = JSON.parse(JSON.stringify(data.powerTemplates));
                        } else {
                            this.anotherAuthorityList.powerTemplates = new Object();
                            this.authorityList.powerTemplates = new Object();
                        }
                        this.anotherAuthorityList.rightLoading = false;
                        break;
                    case 'get_powerTemplateList':
                        this.anotherAuthorityList.powerTemplates = JSON.parse(JSON.stringify(data.powerTemplates));
                        this.anotherAuthorityList.searchTemplates = JSON.parse(JSON.stringify(data.powerTemplates));
                        this.authorityList.powerTemplates = JSON.parse(JSON.stringify(data.powerTemplates));
                        this.authorityList.searchTemplates = JSON.parse(JSON.stringify(data.powerTemplates));
                        this.anotherAuthorityList.rightLoading = false;
                        this.authorityList.leftLoading = false;
                        break;
                    case 'get_employeePowerTemplate':
                        this.anotherAuthorityList.checkedEmployee = data.checkedEmployee;
                        this.anotherAuthorityList.rightLoading = false;
                        break;
                    case 'give_template_to_employee':
                        this.$message({
                            message: '权限模板添加成功',
                            type: 'success'
                        });
                        this.anotherAuthorityList.button_loading = false;
                        for (let key in data.give_template_to_employee) {
                            this.$set(this.anotherAuthorityList.powerTemplates, key, data.give_template_to_employee[key]);
                        }
                        break;
                    case 'delete_employee_from_powerTemplate':
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.authorityList.button_loading = false;
                        this.$delete(this.authorityList.employees, data.employee_id);
                        this.$delete(this.anotherAuthorityList.powerTemplates, data.powerTemplate_id);
                        break;
                    case 'delete_employee_from_powerTemplate_error':
                        this.authorityList.button_loading = false;
                        break;
                    case 'get_employeePowerTemplateList':
                        this.anotherAuthorityList.employees = JSON.parse(JSON.stringify(data.employees));
                        this.anotherAuthorityList.total = JSON.parse(JSON.stringify(data.total));
                        this.authorityList.employees = JSON.parse(JSON.stringify(data.employees));
                        this.authorityList.total = JSON.parse(JSON.stringify(data.total));
                        this.anotherAuthorityList.leftLoading = false;
                        this.authorityList.rightLoading = false;
                        break;
                    case 'get_powers':
                        this.allPowers = data;
                        this.dialog_TemplateUpdateEmployeePower.loading = false;
                        break;
                    case 'update_employeePower':
                        this.$message({
                            message: '员工权限修改成功',
                            type: 'success'
                        });
                        this.dialog_TemplateUpdateEmployeePower.button_loading = false;
                        this.$Win.closeModal();
                        break;
                    case 'update_employeePower_error':
                        this.dialog_TemplateUpdateEmployeePower.button_loading = false;
                        break;
                    case 'updated_powerTemplate':
                        this.$message({
                            message: '权限模板的修改成功',
                            type: 'success'
                        });
                        this.dialog_UpdatePowerTemplate.button_loading = false;
                        this.$Win.closeModal();
                        break;
                    case 'updated_powerTemplate_error':
                        this.dialog_UpdatePowerTemplate.button_loading = false;
                        break;
                    case 'store_powerTemplate':
                        this.$message({
                            message: '权限模板名称添加成功',
                            type: 'success'
                        });
                        if (!this.anotherAuthorityList.checkKey) {
                            this.$set(this.anotherAuthorityList.powerTemplates, data.id, data);
                        }
                        this.anotherAuthorityList.rightLoading = false;
                        this.authorityList.leftLoading = false;
                        this.dialog_AddPowerTemplate.button_loading = false;
                        this.$set(this.authorityList.powerTemplates, data.id, data);
                        this.$Win.closeModal();
                        break;
                    case 'store_powerTemplate_error':
                        this.dialog_AddPowerTemplate.button_loading = false;
                        break;
                    case 'get_checkPower':
                        if (data.type === 'checkPower') {
                            this.dialog_TemplateUpdateEmployeePower.checkedSection = data.checkedSection;
                            this.dialog_TemplateUpdateEmployeePower.employee = data.employee;
                            this.allCheckedPowers = data.allCheckedPowers;
                        } else if (data.type === 'checkPowerTemplate') {
                            this.dialog_UpdatePowerTemplate.name = data.powerTemplate.name;
                            this.allCheckedPowers = data.allCheckedPowers;
                        }
                        let CheckedPowers = Object.keys(data.allCheckedPowers);
                        if (CheckedPowers.length === 0) {
                            this.checkedStudentPowers = [];
                            this.checkedClassroomPowers = [];
                            this.checkedCoursePowers = [];
                            this.checkedClassPowers = [];
                            this.checkedHeadTeacherPowers = [];
                            this.checkedDayTimeTablePowers = [];
                            this.checkedTimeTablePowers = [];
                            this.checkedMonthlyTimeTablePowers = [];
                            this.checkedExamPowers = [];
                            this.checkedSemesterPowers = [];
                            this.checkedSenatePowers = [];
                            this.checkedSignLogPowers = [];
                            this.checkedSittingPowers = [];
                            this.checkedFinancialPowers = [];
                            this.checkedInvoicePowers = [];
                            this.checkedReturnVisitPowers = [];
                            this.checkedEmployeePowers = [];
                            this.checkedAuthorityPowers = [];
                            this.checkedReferrerPowers = [];
                            this.checkedHomePowers = [];
                            this.checkedMenuPowers = [];
                            this.checkedCartPowers = [];
                        }
                        else {
                            if (CheckedPowers.indexOf('home') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.home).length; i++) {
                                    this.checkedHomePowers.push(this.allCheckedPowers.home[i].id);
                                }
                            } else {
                                this.checkedHomePowers = [];
                            }
                            if (CheckedPowers.indexOf('referrer') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.referrer).length; i++) {
                                    this.checkedReferrerPowers.push(this.allCheckedPowers.referrer[i].id);
                                }
                            } else {
                                this.checkedReferrerPowers = [];
                            }
                            if (CheckedPowers.indexOf('authority') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.authority).length; i++) {
                                    this.checkedAuthorityPowers.push(this.allCheckedPowers.authority[i].id);
                                }
                            } else {
                                this.checkedAuthorityPowers = [];
                            }
                            if (CheckedPowers.indexOf('class') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.class).length; i++) {
                                    this.checkedClassPowers.push(this.allCheckedPowers.class[i].id);
                                }
                            } else {
                                this.checkedClassPowers = [];
                            }
                            if (CheckedPowers.indexOf('classroom') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.classroom).length; i++) {
                                    this.checkedClassroomPowers.push(this.allCheckedPowers.classroom[i].id);
                                }
                            } else {
                                this.checkedClassroomPowers = [];
                            }
                            if (CheckedPowers.indexOf('course') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.course).length; i++) {
                                    this.checkedCoursePowers.push(this.allCheckedPowers.course[i].id);
                                }
                            } else {
                                this.checkedCoursePowers = [];
                            }
                            if (CheckedPowers.indexOf('dayTimeTable') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.dayTimeTable).length; i++) {
                                    this.checkedDayTimeTablePowers.push(this.allCheckedPowers.dayTimeTable[i].id);
                                }
                            } else {
                                this.checkedDayTimeTablePowers = [];
                            }
                            if (CheckedPowers.indexOf('employee') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.employee).length; i++) {
                                    this.checkedEmployeePowers.push(this.allCheckedPowers.employee[i].id);
                                }
                            } else {
                                this.checkedEmployeePowers = [];
                            }
                            if (CheckedPowers.indexOf('exam') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.exam).length; i++) {
                                    this.checkedExamPowers.push(this.allCheckedPowers.exam[i].id);
                                }
                            } else {
                                this.checkedExamPowers = [];
                            }
                            if (CheckedPowers.indexOf('financial') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.financial).length; i++) {
                                    this.checkedFinancialPowers.push(this.allCheckedPowers.financial[i].id);
                                }
                            } else {
                                this.checkedFinancialPowers = [];
                            }
                            if (CheckedPowers.indexOf('headTeacher') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.headTeacher).length; i++) {
                                    this.checkedHeadTeacherPowers.push(this.allCheckedPowers.headTeacher[i].id);
                                }
                            } else {
                                this.checkedHeadTeacherPowers = [];
                            }
                            if (CheckedPowers.indexOf('invoice') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.invoice).length; i++) {
                                    this.checkedInvoicePowers.push(this.allCheckedPowers.invoice[i].id);
                                }
                            } else {
                                this.checkedInvoicePowers = [];
                            }
                            if (CheckedPowers.indexOf('menu') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.menu).length; i++) {
                                    this.checkedMenuPowers.push(this.allCheckedPowers.menu[i].id);
                                }
                            } else {
                                this.checkedMenuPowers = [];
                            }
                            if (CheckedPowers.indexOf('returnVisit') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.returnVisit).length; i++) {
                                    this.checkedReturnVisitPowers.push(this.allCheckedPowers.returnVisit[i].id);
                                }
                            } else {
                                this.checkedReturnVisitPowers = [];
                            }
                            if (CheckedPowers.indexOf('semester') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.semester).length; i++) {
                                    this.checkedSemesterPowers.push(this.allCheckedPowers.semester[i].id);
                                }
                            } else {
                                this.checkedSemesterPowers = [];
                            }
                            if (CheckedPowers.indexOf('senate') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.senate).length; i++) {
                                    this.checkedSenatePowers.push(this.allCheckedPowers.senate[i].id);
                                }
                            } else {
                                this.checkedSenatePowers = [];
                            }
                            if (CheckedPowers.indexOf('signlog') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.signlog).length; i++) {
                                    this.checkedSignLogPowers.push(this.allCheckedPowers.signlog[i].id);
                                }
                            } else {
                                this.checkedSignLogPowers = [];
                            }
                            if (CheckedPowers.indexOf('timeTable') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.timeTable).length; i++) {
                                    this.checkedTimeTablePowers.push(this.allCheckedPowers.timeTable[i].id);
                                }
                            } else {
                                this.checkedTimeTablePowers = [];
                            }
                            if (CheckedPowers.indexOf('monthlyTimeTable') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.monthlyTimeTable).length; i++) {
                                    this.checkedMonthlyTimeTablePowers.push(this.allCheckedPowers.monthlyTimeTable[i].id);
                                }
                            } else {
                                this.checkedMonthlyTimeTablePowers = [];
                            }
                            if (CheckedPowers.indexOf('student') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.student).length; i++) {
                                    this.checkedStudentPowers.push(this.allCheckedPowers.student[i].id);
                                }
                            } else {
                                this.checkedStudentPowers = [];
                            }
                            if (CheckedPowers.indexOf('cart') !== -1) {
                                for (let i = 0; i < Object.keys(this.allCheckedPowers.cart).length; i++) {
                                    this.checkedCartPowers.push(this.allCheckedPowers.cart[i].id);
                                }
                            } else {
                                this.checkedCartPowers = [];
                            }
                        }
                        this.dialog_TemplateUpdateEmployeePower.loading = false;
                        this.dialog_UpdatePowerTemplate.loading = false;
                        break;
                    case 'cancel_user':
                        this.$set(this.anotherAuthorityList.employees,data.employee_id,data.employee)
                        this.$set(this.authorityList.employees,data.employee_id,data.employee)
                        break;
                    case 'update_employee_msg':
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.dialog_UpdateEmployee.button_loading=false;
                        this.$set(this.anotherAuthorityList.employees,data.employee.id,data.employee)
                        this.$set(this.authorityList.employees,data.employee.id,data.employee)
                        this.$Win.closeModal();
                        break;
                    case 'update_employee_msg_error':
                        this.dialog_UpdateEmployee.button_loading=false;
                        break;
                    case 'store_employee':
                        this.$message({
                            message: '创建成功',
                            type: 'success'
                        });
                        this.anotherAuthorityList.total+=1
                        this.authorityList.total+=1
                        this.$Win.closeModal();
                        break;
                    case 'get_employeeAccount':
                        this.dialog_UpdateAccount.phone=data.phone;
                        this.dialog_UpdateAccount.button_loading = false;
                        break;
                    case 'get_employeeAccount_error':
                        this.dialog_UpdateAccount.button_loading = false;
                        break;
                    case 'update_employeeAccount':
                        this.$message({
                            message: '发送成功',
                            type: 'success'
                        });
                        this.dialog_UpdateAccount.button_loading=false
                        this.$Win.closeModal();
                        break;
                    case 'update_employeeAccount_error':
                        this.dialog_UpdateAccount.button_loading=false
                        break;
                    case 'set_sms_to_register':
                        this.$message({
                            message: '发送成功',
                            type: 'success'
                        });
                        break;
                }
            },
            handleChangeList() {
                this.activeList = !this.activeList;
            },
            handleAddTemplate() {
                this.$Win.openModal('Dialog_AddPowerTemplate', 400, 200, '新增权限模板');
            },
        }
    }
</script>

<style scoped>
</style>
